export default __webpack_public_path__ + "static/Quickinstallation_Tile_8015_Step_02-ab128b7534fe50c6ca354a10140c6e8e.webp";